var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"il-wrapper"},[_c('header-banner'),_c('div',{staticClass:"il-container"},[_c('navigation'),_c('home-video')],1),_c('footer-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }